<template>

    <v-main class="main-login">

        <v-container fluid class="fill-height">

            <v-row justify="center" align="center" align-content="center">

                <v-col cols="12" sm="6" md="5" lg="4" xl="3">

                    <v-card
                        rounded="lg"
                        class="px-10 py-12 text-center ma-auto"
                        width="80%"
                        elevation="4"
                    >
                        <v-img
                            src="images/logo_login.svg"
                            width="166"
                            class="mx-auto"
                        />

                        <div class="mt-8 mb-6">
                            <h1 class="font-weight-bold primary--text">
                                {{ $t("global.app_name") }}
                            </h1>
                            <h2 class="font-weight-light">
                                {{ $t("login.login") }}
                            </h2>
                        </div>

                        <v-form ref="loginForm"
                                v-model="valid"
                                @keypress.native.enter="login"
                        >

                            <v-text-field
                                v-model="identifier"
                                :label="$t('login.identifier')"
                                type="text"
                                outlined
                                required
                                persistent-placeholder
                                placeholder=" "
                                dense
                                :rules="[ v => !!v || 'Email requis']"
                            />

                            <v-text-field
                                v-model="password"
                                :label="$t('login.password')"
                                type="password"
                                outlined
                                dense
                                persistent-placeholder
                                placeholder=" "
                                required
                                :rules="[ v => !!v || 'Mot de passe requis']"
                            />

                            <v-btn
                                elevation="0"
                                block
                                class="mb-3"
                                color="primary"
                                type="button"
                                :loading="loading"
                                @click="login"
                                @keypress.native.enter="login"
                            >
                                {{ $t("login.connexion") }}
                            </v-btn>

                            <a @click="$router.push({ name: 'ChangePassword' })">
                                {{ $t("login.change_password") }}
                            </a>

                        </v-form>

                    </v-card>

                </v-col>

            </v-row>

        </v-container>

    </v-main>

</template>

<script>

import {events} from "../events";

export default {
    name: "Login",
    data() {
        return {
            identifier: null,
            password: null,
            showForm: false,
            loading: false,
            valid: false,

        };
    },
    mounted() {
        this.$root.clearStorage()
    },
    methods: {
        login() {
            if (!this.$refs.loginForm.validate()) {
                return
            }


            this.loading = true
            this.$auth.login({
                data: {
                    provider: "users",
                    credentials: {
                        login: this.identifier,
                        password: this.password
                    }
                }
            })
                .catch(err => {
                    if (err.response.status === 404) {
                        events.$emit('notificationFailure',
                            this.$t('login.not_found'))
                    }
                })
                .finally(() => this.loading = false)

        }
    }
};
</script>
